import { CLOUD_CLIENT } from '../constant/actionTypes';

const getCloudClientSoftwareList = (state, action) => {
  switch (action.type) {
    case CLOUD_CLIENT.SOFTWARES_LIST.INITIATE:
      return { isFetching: true, data: action.payload };
    case CLOUD_CLIENT.SOFTWARES_LIST.SUCCESS:
      return { isFetching: false, data: action.payload };
    case CLOUD_CLIENT.SOFTWARES_LIST.ERROR:
      return { isFetching: false, data: action.payload };
    default:
      return state || [];
  }
};

export default getCloudClientSoftwareList;
